import WorkbenchManager from 'Shared/workbench_manager';

// eslint-disable-next-line no-var
export var TopicSelector = {
   select: function (button, variantid, wikiid, useIndicator) {
      WorkbenchManager.addItem(variantid, wikiid, useIndicator);
      this.toggleButtonState(button, /* isOwned */ true);
   },

   deselect: function (button, variantid, wikiid, useIndicator) {
      WorkbenchManager.removeItem(variantid, wikiid, useIndicator);
      this.toggleButtonState(button, /* isOwned */ false);
   },

   // button: one element, or anything iterable of elements.
   toggleButtonState: function (button, isOwned) {
      const buttons = button instanceof Element ? [button] : Array.from(button);
      const checkIcons = document.querySelectorAll('.save-topic-check');
      const plusIcons = document.querySelectorAll('.save-topic-plus');

      if (isOwned) {
         buttons.forEach(el => el.classList.add('checked'));
         plusIcons.forEach(el => el.classList.add('hidden!'));
         checkIcons.forEach(el => el.classList.remove('hidden!'));
      } else {
         buttons.forEach(el => el.classList.remove('checked'));
         checkIcons.forEach(el => el.classList.add('hidden!'));
         plusIcons.forEach(el => el.classList.remove('hidden!'));
      }
   },

   updateVariantDropdownState: function () {
      let button = document.querySelectorAll(
         '#variant-save-topic-button, #generic-save-topic-button'
      );

      let owned = Array.from(document.querySelectorAll('.js-workbench-checkbox')).some(
         checkbox => checkbox.checked
      );

      TopicSelector.toggleButtonState(button, owned);
   },
};
